import { Megaphone, Search, Target, MapPin, Smartphone, Globe, Sparkles, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "@/data/services";

const ICONS = { Megaphone, Search, Target, MapPin, Smartphone, Globe, Sparkles };

export default function Services({ excludeSlug, heading, subheading }) {
  const items = excludeSlug ? SERVICES.filter((s) => s.slug !== excludeSlug) : SERVICES;
  return (
    <section id="services" className="relative py-14 md:py-20" data-testid="services-section">
      <div className="mx-auto max-w-6xl px-5 md:px-6">
        <div className="mb-10 flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-blue-400">
              {heading ? "Suggested" : "What we do"}
            </span>
            <h2 className="mt-2 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
              {heading || "Full-stack growth services"}
            </h2>
          </div>
          <p className="max-w-md text-sm text-slate-400">
            {subheading || "Everything you need to acquire, convert and retain customers — under one roof."}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((s, i) => {
            const Icon = ICONS[s.iconKey] || Megaphone;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="card-hover glass group relative block overflow-hidden rounded-2xl p-5 animate-fade-up"
                style={{ animationDelay: `${0.08 * i}s` }}
                data-testid={`service-card-${i}`}
              >
                <div
                  className={`absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br ${s.accent} blur-2xl opacity-70 transition-opacity group-hover:opacity-100`}
                  aria-hidden
                />
                <div className="relative">
                  <div className="mb-4 flex items-start justify-between">
                    <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-slate-900/60">
                      <Icon className={`h-5 w-5 ${s.iconColor}`} />
                    </div>
                    <ArrowUpRight className="h-4 w-4 text-slate-500 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-blue-300" />
                  </div>
                  <h3 className="text-base font-semibold text-white">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{s.short}</p>
                  <div className="mt-4 text-xs font-semibold text-blue-300 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    Explore service →
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
